import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { GenericDialog } from 'app/components/Alerts/GenericDialog';

/**
 * Component to confirm whether Lands/GTG is completed
 */
const LandsGtgPopup = ({ open, setDialogOpen }: { open: boolean; setDialogOpen: Function }) => {
  const { t } = useTranslation();

  return (
    <GenericDialog
      open={open}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      onClose={(e, reason) => {
        if (reason === 'backdropClick') return;
        setDialogOpen(false);
      }}
      dialogTitleProps={{
        style: { paddingTop: '20px' },
        text: t('cancelModal.confirmation.handleProceed'),
      }}
      dialogActions={[
        {
          text: t('cancelModal.confirmation.OK'),
          variant: 'contained',
          color: 'primary',
          onClick: () => setDialogOpen(false),
          disabled: false,
        },
      ]}
    >
      <Typography style={{ color: '#707070', fontSize: '16px' }}>
        {t('placement.profile.tabs.passportCredentialXGrid.editConfirmationMessage')}
      </Typography>
    </GenericDialog>
  );
};

export default LandsGtgPopup;
